/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Reviews_SubtitleInputs */

const es_marketplace_seo_spain_reviews_subtitle = /** @type {(inputs: Marketplace_Seo_Spain_Reviews_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencias reales de alquiler de barcos y experiencias náuticas compartidas en España.`)
};

const gl_marketplace_seo_spain_reviews_subtitle = /** @type {(inputs: Marketplace_Seo_Spain_Reviews_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencias reais de alugueiro de barcos e excursiones náuticas en España.`)
};

const en_marketplace_seo_spain_reviews_subtitle = /** @type {(inputs: Marketplace_Seo_Spain_Reviews_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real experiences from boat rentals and day trips across Spain.`)
};

/**
* | output |
* | --- |
* | "Real experiences from boat rentals and day trips across Spain." |
*
* @param {Marketplace_Seo_Spain_Reviews_SubtitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_reviews_subtitle = /** @type {((inputs?: Marketplace_Seo_Spain_Reviews_SubtitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Reviews_SubtitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_reviews_subtitle(inputs)
	if (locale === "en") return en_marketplace_seo_spain_reviews_subtitle(inputs)
	return es_marketplace_seo_spain_reviews_subtitle(inputs)
});